import { StateCreator } from 'zustand';
import { persist } from 'zustand/middleware';

import { storeCreator } from '@/utils/store/store.utils';

interface State {
  timestamps: Record<string, number>;
  setSendTimestamp: (key: string, value: number) => void;
  resetTimestamp: (key: string) => void;
  resetAll: () => void;
}

const LOCAL_STORAGE_KEY = 'contacts-verification-timestamps-storage';

export const useContactResendVerificationStore = storeCreator<State>(persist(
  (set) => ({
    timestamps: {},

    setSendTimestamp: (key: string, value: number) => set((state) => ({
      timestamps: {
        ...state.timestamps,
        [key]: value,
      },
    })),

    resetTimestamp: (key: string) => set((state) => {
      const { [key]: _, ...rest } = state.timestamps;
      return { timestamps: rest };
    }),

    resetAll: () => set(() => ({
      timestamps: {},
    })),
  }),
  {
    name: LOCAL_STORAGE_KEY,
    partialize: (state) => ({ timestamps: state.timestamps }),
  }) as StateCreator<State>,
);

export default useContactResendVerificationStore;
